import Post from 'types/Post';
import { IGenericResponse } from 'state/interfaces';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ICreateProductRequest } from 'state/interfaces/Product';

export const productApi = createApi({
  reducerPath: 'productApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${process.env.REACT_APP_SERVER_ENDPOINT}/post`, credentials: "include" }),
  endpoints: (builder) => ({
    getProduct: builder.query<Post & {userName: string}, string>({
      query: id => ({
        url: `/${id}`
      }),
      transformResponse: (results: IGenericResponse<Post & {userName: string}>) => results.data,
    }),
    createProduct: builder.mutation<string, ICreateProductRequest>({
      query: body => ({
        url: ``,
        method: "POST",
        body
      }),
      transformResponse: (results: IGenericResponse<string>) => results.data,
    }),
    getMyProducts: builder.query<(Post & { userImage: string; rented: boolean })[], void>({
      query: () => ({
        url: `my-products`,
      }),
      transformResponse: (results: IGenericResponse<(Post & { userImage: string; rented: boolean })[]>) => results.data,
    }),
    getMyRents: builder.query<(Post & { userImage: string })[], void>({
      query: () => ({
        url: `my-rents`,
      }),
      transformResponse: (results: IGenericResponse<(Post & { userImage: string })[]>) => results.data,
    }),
  }),
});

export const {
    useGetProductQuery,
    useCreateProductMutation,
    useGetMyRentsQuery,
    useGetMyProductsQuery
} = productApi;